var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivitySvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ActivitySvg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 26.667h21.333c0.733 0 1.333 0.6 1.333 1.333s-0.6 1.333-1.333 1.333h-21.333c-0.733 0-1.333-0.6-1.333-1.333s0.6-1.333 1.333-1.333zM26.667 9.333c0.736 0 1.333 0.597 1.333 1.333v12c0 0.736-0.597 1.333-1.333 1.333h-21.333c-0.736 0-1.333-0.597-1.333-1.333v-12c0-0.736 0.597-1.333 1.333-1.333h21.333zM25.333 12h-18.667v9.333h18.667v-9.333zM5.333 4h21.333c0.733 0 1.333 0.6 1.333 1.333s-0.6 1.333-1.333 1.333h-21.333c-0.733 0-1.333-0.6-1.333-1.333s0.6-1.333 1.333-1.333z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySvg);
export default __webpack_public_path__ + "static/media/ActivitySvg.1a23ea77c35665a5d87704ce60406898.svg";
export { ForwardRef as ReactComponent };